import { createSelector } from 'reselect';

import { getIsFulfilled as getIsCountriesFulfilled } from './countries/countries.selectors';
import { getIsFulfilled as getIsBrandingFulfilled } from './branding/branding.selectors';
import { getIsFulfilled as getIsUsersFulfilled } from './users/users.selectors';

export const getIsCommonDataLoaded = createSelector(
  getIsUsersFulfilled,
  getIsCountriesFulfilled,
  getIsBrandingFulfilled,
  (isUsersFulfilled, isCountriesFulfilled, isBrandingFulfilled) =>
    isUsersFulfilled && isCountriesFulfilled && isBrandingFulfilled,
);
